import React from "react";
import "./blogs.css";

const Meet_Saiya = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src="placement-postulates/blogs/Meet-Saiya/dp.jpg"
            style={{ height: "315px", width: "90%" }}
            alt="meet"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Meet Saiya</h2>
            <small>Jr. Structural Engineer, AECOM India</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction:</h3>
            <p>
              This blog will stand out from the other postulates in many ways.
              But let’s get introductions out of the way before we dive in. I’m
              Meet, final year M. Tech in Infrastructure Engineering and
              Management. My placement journey has been one hell of a
              rollercoaster ride, from being unaware in the first semester to
              rejecting an off campus offer in the last. So, tag along for the
              ride and hopefully it will be helpful for your placements!
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Meet-Saiya/1.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>First Semester: The Online Start</h3>
            <p>
              Joining college through Zoom was disappointing due to the lack of
              real interaction with seniors and fellow students. The absence of
              guidance left me unprepared for placements. However, I became the
              Marketing Head for ECell, and things started falling into place.
              Online interactions helped me learn about different roles,
              preparation strategies, and tests for placements. Finally stepping
              on campus in January heightened my excitement for the
              opportunities ahead. Although the virtual beginning was
              challenging, it eventually paved the way for growth and success.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Second Semester: The Preparation Phase</h3>
            <p>
              The past few semesters have been a whirlwind of challenges and
              opportunities, but I've managed to navigate through them with
              determination and adaptability. While pursuing core civil
              engineering was my initial goal, I embraced the reality of limited
              opportunities and diversified my prospects by preparing for data
              science, consulting, and APM roles. To strengthen my resume, I
              sought out diverse projects from professors and alumni, both core
              and non-core, and the fact that I got paid for these projects was
              an added bonus.
              <br />
              <br />
              Realizing the importance of data structures, I strategically chose
              a thesis topic that intersected both core and non-core elements,
              allowing me to learn and grow along the way. And the efforts paid
              off when I secured a sustainability consulting internship at the
              Bureau of Indian Standards, making me the only student from IITK
              to be selected. It's been a journey of resilience and seizing
              opportunities, and I'm excited about what the future holds as I
              continue to pave my path in the realm of infrastructure asset
              management and beyond.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Summer Term: Preparing for Interviews</h3>
            <p>
              During my summer in Delhi, I interned at BIS, working on research
              papers and consulting pitch decks for APMs. I dabbled in data
              science but didn't feel a strong connection to it. Though I had an
              impactful resume, I needed to prepare for the upcoming recruitment
              season. Creating an Excel sheet with potential companies helped me
              focus on roles that aligned with my preferences. However, there
              were no consulting or APM opportunities for PGs, so I shifted my
              focus to DS, BA, and core roles. Despite uncertainties, I remained
              optimistic about the opportunities ahead.
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="placement-postulates/blogs/Meet-Saiya/2.JPG"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Third Semester: Beginning of Placement Activities</h3>
            <p>
              As I reflect on my journey, it's been a roller-coaster ride filled
              with uncertainty and challenges. The placement activities began
              early on, and resumes were collected, marking the start of a
              nerve-wracking phase. Transitioning from academics to thesis work
              for my PG wasn't easy either, as I grappled with the insecurities
              of venturing into the world of research amidst the ever-present
              uncertainties of job placements.
              <br />
              <br />
              While my peers seemed to have a constant stream of tests and
              interviews, I found myself patiently waiting, applying only to the
              limited companies that truly aligned with my aspirations. The fear
              of not fitting any specific roles offered for placements gnawed at
              me, especially for those pursuing core disciplines, leaving little
              room for other options. But I held on to the belief that things
              would have to change for the better.
              <br />
              <br />
              As the DPC (Designated Placement Coordinator), I took matters into
              my own hands and started inviting core companies to our campus. It
              wasn't an easy task, as some were hesitant to recruit from IITs
              due to perceived high attrition rates. Nevertheless, I persevered,
              reaching out to various companies and expanding my network through
              LinkedIn connections. In the process, I even extended invitations
              to non-core companies, broadening my horizons and increasing the
              chances of landing roles that piqued my interest.
              <br />
              <br />
              Amidst the chaos of interviews and the pressure to secure a job
              quickly, I decided to explore the possibility of core roles
              despite my management background. One such interview with AECOM, a
              major player in the industry, surprised me with its focus on my
              thesis work and the depth of technical questions. Yet, my strong
              fundamentals and passion for the subject shone through, leading to
              a meaningful discussion rather than a conventional interview.
              Walking out, I felt a sense of confidence, and soon enough, I
              received the good news—I had been selected.
              <br />
              <br />
              Looking back, this journey has taught me valuable lessons in
              perseverance, adaptability, and the importance of pursuing what
              truly resonates with me. The path was uncertain, and at times, it
              felt overwhelming, but I trusted my instincts and excel sheet,
              allowing me to focus on quality over quantity in my job
              applications.
              <br />
              <br />
              As I move forward with newfound confidence in my core role, I'm
              grateful for the challenges that shaped me and the opportunities
              that awaited me at the end of this winding road. I've learned that
              it's essential to stay true to oneself, embrace change, and never
              stop believing in the power of hard work and determination. The
              future may be uncertain, but I now face it with a sense of
              excitement and readiness to embrace whatever lies ahead.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Fourth Semester: Landing AECOM and Making a Tough Decision</h3>
            <p>
              After successfully completing my thesis work, I attended a summer
              school on Large scale optimization at IITK, eager to learn more
              for my research. During the event, I had pleasant interactions
              with various participants, including a senior person from
              Unilever, whom I didn't know at the time. He later offered me an
              exciting role at Unilever that aligned with my thesis work.
              Despite the substantial salary hike and the company's reputation,
              I hesitated about accepting the offer. Seeking advice from
              professors, friends, and alums, I gained valuable perspectives.
              Eventually, I turned down the offer and accepted a job at AECOM,
              where I'll be designing infrastructure for their global delivery
              centre. I hope I made the right decision and don't come to regret
              it. My thesis was successful, and I graduated on time, which is
              worth celebrating. My advice from this experience is to seek
              advice from alums at various levels and locations to make informed
              career decisions.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Meet-Saiya/3.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Tips and Gyan for Placements:</h3>
            <p>
              As I reflect on the journey of placements, I can't emphasize
              enough how crucial preparation is. Starting early gave me an
              advantage, enabling me to create a well-structured plan. Making a
              list of preferred companies and aligning my resumes to their needs
              was essential. But beyond a great resume, I realized that
              attitude, communication, and interpersonal skills mattered
              immensely.
              <br />
              Researching target companies thoroughly proved to be a
              game-changer during interviews. Understanding their values,
              projects, and leadership helped me engage in meaningful
              conversations. I learned to ask insightful questions about their
              experiences, making a lasting impression.
              <br />
              While peers' opinions mattered, I focused on my personal
              aspirations rather than being swayed by others. CTC alone
              shouldn't dictate decisions; finding the right role and industry
              for my long-term growth became my priority.
              <br />
              Mock interviews and seeking advice from diverse sources
              strengthened my interview skills and decision-making process. And
              during challenging times, camaraderie with friends provided
              much-needed support and helped me stay composed amidst rejections.
              <br />
              In the end, success wasn't merely about luck but the result of
              thorough preparation, a learning attitude, and the ability to
              stand out in the crowd. I'm grateful for this transformative
              experience, and I'm excited to embrace the future with confidence
              and determination.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Conclusion:</h3>
            <p>
              Lastly, take risks and follow what you truly like. You’ll
              eventually get the job you like if you work hard and have a unique
              skill set. In rare cases like mine, it might come to you rather
              than you reaching out for it.
              <br />
              Best of luck!
              <br />
              Oh, and do not hesitate to reach out to me for any help : )
              <br />
              <br />
            </p>

            <p>
              <ul>
                <li>
                  <b>Resume:</b>{" "}
                  <a
                    href="https://drive.google.com/file/d/1677il6rPW4zV23ytyBdl_ak3PUJhuBoN/view"
                    className="resume-link"
                  >
                    [View Resume]
                  </a>
                </li>
                <li>
                  <b>Contact Here:</b>{" "}
                  <a href="mailto:meet@iitkalumni.org" className="resume-link">
                    <i className="fa fa-envelope"></i>
                  </a>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Meet_Saiya;
